
import { BrowserRouter as Router, Routes, Route,  } from "react-router-dom";
import './App.css';
import PMSAdminDashboard from './Components/PMS_ADMIN/PMSRegularFlow/PMSAdminDashboard';
import PMSAdminListOfSubjects from "./Components/PMS_ADMIN/PMSRegularFlow/PMSAdminListOfSubjects";
import PMSAdminAddPI from "./Components/PMS_ADMIN/PMS_PI_Details/PMSAdminAddPI";
import PMSAdminRecordSubject from "./Components/PMS_ADMIN/PMSRegularFlow/PMSAdminRecordSubject";
import PMSSiteDetails from "./Components/PMS_ADMIN/PMS_Site_Details/PMSSiteDetails";
import PMSAdverseEventBank from "./Components/PMS_ADMIN/PMS_Event_Bank/PMSAdverseEventBank";
import PMSStudyDetails from "./Components/PMS_ADMIN/PMS_Study_Details/PMSStudyDetails";
import LoginPage from "./Components/LoginPage";
import PMSAdminAddQR from "./Components/PMS_ADMIN/PMS_Add_Quality_Reviewer/PMSAdminAddQR";
import PMSAdminAddMR from "./Components/PMS_ADMIN/PMS_Add_Medical_Reviewer/PMSAdminAddMR";
import SubjectRegistration from "./Components/PI/SubjectFlow/Subject_Registration";
import PIDashboard from "./Components/PI/PIFlow/PIDashBoard";
import PISubjectsList from "./Components/PI/PIFlow/PISubjectsList";
import PIAdverseEvents from "./Components/PI/PIFlow/PIAdverseEvents";
import PMSAdminPIList from "./Components/PMS_ADMIN/PMS_PI_Details/PMSAdminPIList";
import PMSAdminQRList from "./Components/PMS_ADMIN/PMS_Add_Quality_Reviewer/PMSAdminQRList"
import PMSAdminMRList from "./Components/PMS_ADMIN/PMS_Add_Medical_Reviewer/PMSAdminMRList"

import PMSAdminEditPI from "./Components/PMS_ADMIN/PMS_PI_Details/PMSAdminEditPI";
import PMSAdminEditQR from "./Components/PMS_ADMIN/PMS_Add_Quality_Reviewer/PMSAdminEditQR";
import PMSAdminEditMR from "./Components/PMS_ADMIN/PMS_Add_Medical_Reviewer/PMSAdminEditMR";
import PMSAllReports from "./Components/PMS_ADMIN/PMSRegularFlow/PMSAllReports";
import PMSAdminChangeLogger from "./Components/PMS_ADMIN/PMSRegularFlow/PMSAdminChangeLogger";
import PMSAdminChangeLogger2 from "./Components/PMS_ADMIN/PMSRegularFlow/PMSAdminChangeLogger2";
import PMSAdminCIOMSreports from "./Components/PMS_ADMIN/PMSRegularFlow/PMSAdminCIOMSreports";
import PMSAdminUserManual from "./Components/PMS_ADMIN/PMSRegularFlow/PMSAdminUserManual.jsx";

import ReviewerdashBoard from "./Components/Quality_Reviewer/ReviewerDashBoard"
import ReviewList from "./Components/Quality_Reviewer/ReviewList"

import { Provider } from 'react-redux';
import store from './Redux/Store';
import PMSNewStudySetup from "./Components/PMS_ADMIN/PMS_Study_Details/PMSNewStudySetup";
import CheckboxExample from "./Components/PMS_ADMIN/PMS_Study_Details/CheckboxExample";
import PMSAdminAddMarketingHead from "./Components/PMS_ADMIN/PMS_Add_Marketing_Head/PMSAdminAddMarketingHead";
import PMSAdminEditMarketingHead from "./Components/PMS_ADMIN/PMS_Add_Marketing_Head/PMSAdminEditMarketingHead";

import PMSAdminMarketingHeadList from "./Components/PMS_ADMIN/PMS_Add_Marketing_Head/PMSAdminMarketingHeadList";
import AddNewAeToSubject from "./Components/PI/PIFlow/AddNewAeToSubject";
import AddNewDoseToSubject from "./Components/PI/PIFlow/AddNewDoseToSubject";
import ReviewRejectedEvents from "./Components/PI/RejectedEvents/ReviewRejectedEvents";
import MarketingHeadDashboard from "./Components/Marketing_Head/MarketingHeadDashBoard";
import MarketingHeadAddStaff from "./Components/Marketing_Head/MarketingHeadAddStaff";
import MarketingStafList from "./Components/Marketing_Head/MarketingStafList";
import MarketingHeadSubjectList from "./Components/Marketing_Head/MarketingHeadSubjectList";
import MarketingHeadUserManual from "./Components/Marketing_Head/MarketingHeadUserManual";
import MarketingStaffUserManual from "./Components/Marketing_Staff/MarketingStaffUserManual";
 

import PIRejectedEvents from "./Components/PI/PIFlow/PIRejectedEvents";
import AddAeToSubjectDose from "./Components/PI/PIFlow/AddAeToSubjectDose";

import PIRejectEventsEdit from "./Components/PI/PIFlow/PIRejectEventsEdit";
import PIUserManual from "./Components/PI/PIFlow/PIUserManual";

import UpdateAEDetails from "./Components/PI/PIFlow/UpdateAEDetails";
import MarketingStaffDashboard from "./Components/Marketing_Staff/MarketingStaffDashboard"
import MarketingStaffSubjectList from "./Components/Marketing_Staff/MarketingStaffSubjectList"
import ViewAEDetails from "./Components/Marketing_Staff/ViewAEDetails";

import UserInitialPasswordSetup  from "./Components/UserInitialPasswordSetup";

import MedicalReviewerDashboard from "./Components/Medical_Reviewer/MedicalReviewerDashboard";
import MedicalReviewerReviewList from "./Components/Medical_Reviewer/MedicalReviewerReviewList.jsx";
import MedicalReviewerUserManual from "./Components/Medical_Reviewer/MedicalReviewerUserManual";
import QrSubjectReview from "./Components/Quality_Reviewer/QrSubjectReview";
import QualityReviewerUserManual from "./Components/Quality_Reviewer/QualityReviewerUserManual";
import RejectedSubjects from "./Components/PI/PIFlow/RejectedSubjects";
import RejectedSubjEdit from "./Components/PI/PIFlow/RejectedSubjEdit";

import MarketingHeadSites from "./Components/Marketing_Head/MarketingHeadSites";
import PMSSubjectsReview from "./Components/PMS_ADMIN/PMSRegularFlow/PMSSubjectsReview";
import PIstudysiteMapping from "./Components/PMS_ADMIN/PMS_PI_Details/PIstudysiteMapping";
import NavBarLeft, { MarketingHeadFlow, MarketingStaffFlow, MedicalReviewerFlow, PIFlowLeftNavBar, QRFlowLeftNavBar } from "./Components/ReusableComp/NavBarLeft.jsx";
import { MARKETING_HEAD, MARKETING_STAFF, MEDICAL_REVIEWER, PMS_ADMIN, PRINCIPAL_INVESTIGATOR, QUALITY_REVIEWER } from "./utilities.jsx";

function App() {
  
  return (
    <Provider store={store}>
      <div className="App">
        <Router>

          <Routes>
            <Route path="/" element={<LoginPage />} />


            {localStorage.role_code == PMS_ADMIN &&


              <Route
                path="/*"
                element={
                  <div>
                    <NavBarLeft />
                    <Routes>
                      <Route path="/pmsadmindashboard" element={<PMSAdminDashboard />} />
                      <Route path="/pmsadminlistofsubjects" element={<PMSAdminListOfSubjects />} />
                      <Route path="/pmsadminaddpi" element={<PMSAdminAddPI />} />
                      <Route path="/pmsadminrecordsubject" element={<PMSAdminRecordSubject />} />
                      <Route path="/pmsadminmarketinghead" element={<PMSAdminAddMarketingHead />} />
                      <Route path="/pmsadminmarketingheadlist" element={<PMSAdminMarketingHeadList />} />
                      <Route path="/pmsadverseeventbank" element={<PMSAdverseEventBank />} />
                      <Route path="/pmsstudydetails" element={<PMSStudyDetails />} />
                      <Route path="/pmssitedetails" element={<PMSSiteDetails />} />
                      <Route path="/pmsnewstudysetup" element={<PMSNewStudySetup />} />
                      <Route path="/pistudysitemapping" element={<PIstudysiteMapping />} />
                      <Route path="/CheckboxExample" element={<CheckboxExample />} />
                      <Route path="/pmsadminaddqr" element={<PMSAdminAddQR />} />
                      <Route path="/pmsadminaddmr" element={<PMSAdminAddMR />} />
                      <Route path="/pmssubjectsreview" element={<PMSSubjectsReview />} />
                      <Route path="/pmsallreports" element={<PMSAllReports />} />
                      <Route path="/pmsciomsreports" element={<PMSAdminCIOMSreports />} />
                      <Route path="/pmschangelogger2" element={<PMSAdminChangeLogger2 />} />
                      <Route path="/pmsusermanual" element={<PMSAdminUserManual />} />

                      <Route path="/editmarketingHead" element={<PMSAdminEditMarketingHead />} />
                      <Route path="/pilist" element={<PMSAdminPIList />} />
                      <Route path="/editprincipalinvestigator" element={<PMSAdminEditPI />} />
                      <Route path="/editqualityreviewer" element={<PMSAdminEditQR />} />
                      <Route path="/editmedicalreviewer" element={<PMSAdminEditMR />} />

                      <Route path="/qrlist" element={<PMSAdminQRList />} />
                      <Route path="/mrlist" element={<PMSAdminMRList />} />

                    </Routes>
                  </div>}
              />

            }

            {/* ===============PIFlow==================== */}
            {localStorage.role_code == PRINCIPAL_INVESTIGATOR &&


              <Route
                path="/*"
                element={
                  <div>
                    <PIFlowLeftNavBar />
                    <Routes>

                      <Route path="/subjectregistration" element={<SubjectRegistration />} />
                      <Route path="/pidashboard" element={<PIDashboard />} />
                      <Route path="/piadverseevents" element={<PIAdverseEvents />} />
                      <Route path="/pisubjectslist" element={<PISubjectsList />} />
                      <Route path="/addnewaetosubject" element={<AddNewAeToSubject />} />
                      <Route path="/addnewdosetosubject" element={<AddNewDoseToSubject />} />
                      <Route path="/reviewrejectedevents" element={<ReviewRejectedEvents />} />
                      <Route path="/pirejectedevents" element={<PIRejectedEvents />} />
                      <Route path="/addnewadverseevent" element={<AddAeToSubjectDose />} />
                      <Route path="/rejectedsubjects" element={<RejectedSubjects />} />
                      <Route path="/rejectedsubjedit" element={<RejectedSubjEdit />} />
                      <Route path="/pirejectedeventsedit" element={<PIRejectEventsEdit />} />
                      <Route path="/updateAEDetails" element={<UpdateAEDetails />} />
                      <Route path="/piusermanual" element={<PIUserManual/>} />
                    </Routes>
                  </div>}
              />

            }


            {/* ===============Marketing Head Flow==================== */}
            {localStorage.role_code == MARKETING_HEAD &&


              <Route
                path="/*"
                element={
                  <div>
                    <MarketingHeadFlow />
                    <Routes>
                      <Route path="/mhdashboard" element={<MarketingHeadDashboard />} />
                      <Route path="/mhsubjectlist" element={<MarketingHeadSubjectList />} />
                      <Route path="/mhaddstaff" element={<MarketingHeadAddStaff />} />
                      <Route path="/mhsitesdetails" element={<MarketingHeadSites />} />
                      <Route path="/marketingstafflist" element={<MarketingStafList />} />
                      <Route path="/marketingheadusermanual" element={<MarketingHeadUserManual />} />
                    </Routes>
                  </div>}
              />
            }

            {/* ===============QRFlow==================== */}
            {localStorage.role_code == QUALITY_REVIEWER &&


              <Route
                path="/*"
                element={
                  <div>
                    <QRFlowLeftNavBar />
                    <Routes>
                      <Route path="/qrdashboard" element={<ReviewerdashBoard />} />
                      <Route path="/reviewlist" element={<ReviewList />} />
                      <Route path="/qrsubjectreview" element={<QrSubjectReview />} />
                      <Route path="/qrusermanual" element={<QualityReviewerUserManual />} />
                    </Routes>
                  </div>}
              />
            }

            <Route path="/passwordsetup" element={<UserInitialPasswordSetup />} />

            {/* =====================MarketingStaffFlow================ */}
            {localStorage.role_code == MARKETING_STAFF &&

              <Route
                path="/*"
                element={
                  <div>
                    <MarketingStaffFlow />
                    <Routes>
                      <Route path="/marketingstaffdashboard" element={<MarketingStaffDashboard />} />
                      <Route path="/marketingstaffsubjectlist" element={<MarketingStaffSubjectList />} />
                      <Route path="/viewAEDetails" element={<ViewAEDetails />} />
                      <Route path="/marketingstaffusermanual" element={<MarketingStaffUserManual />} />
                    </Routes>
                  </div>}
              />
            }

           
          {/* ============================Medical Reviewer==================== */}
          {localStorage.role_code == MEDICAL_REVIEWER &&
            
              <Route
                path="/*"
                element={
                  <div>
                    <MedicalReviewerFlow />
                    <Routes>
                      <Route path="/mrdashboard" element={<MedicalReviewerDashboard />} />
                      <Route path="/mrreviewlist" element={<MedicalReviewerReviewList />} />
                      <Route path="/mrusermanual" element={<MedicalReviewerUserManual />} />
                    </Routes>


                  </div>}
              />
             }
                    </Routes>

        </Router>

      </div>
    </Provider>
  );
}

export default App;
